import styled from 'styled-components';

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: 1.6;
  p {
    margin: 0;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
  a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 3px;
  }
  input,
  select,
  textarea {
    box-sizing: border-box;
    max-width: 100%;
  }
`;
export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;
export const Card = styled(Stack)`
  background: ${({ theme }) => theme.color.surface};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: 16px;
`;
export const Small = styled.p`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;
export const Quote = styled.blockquote`
  margin: 0;
  padding: 8px 12px;
  border-left: 2px solid ${({ theme }) => theme.color.hairSoft};
  overflow-wrap: anywhere;
`;
export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  input,
  select,
  textarea {
    min-height: 40px;
    padding: 8px;
    border: 1px solid ${({ theme }) => theme.color.hairSoft};
    border-radius: ${({ theme }) => theme.radius.sm};
    color: ${({ theme }) => theme.color.textPrimary};
    background: ${({ theme }) => theme.color.surface};
    font: inherit;
  }
  /* A bare textarea here fell back to the browser's white box in dark mode (the AMA "Your question"
     field), because only input and select were themed. */
  textarea {
    min-height: 100px;
    resize: vertical;
  }
`;
